export default defineNuxtRouteMiddleware(async (to: any) => {
  if (!to.query.promoCode) {
    return;
  }

  const { getSecureQueryParam } = useRoutes();

  const promoCode = getSecureQueryParam(to.query.promoCode);

  if (!promoCode) {
    return;
  }

  const { getRouteBaseName, goToLocaleRoute } = useRoutes();

  const routeName = getRouteBaseName(to);

  if (routeName !== 'index') {
    return;
  }

  return await goToLocaleRoute({
    name: 'cupom-cupom',
    params: { cupom: String(promoCode) },
  });
});
